import React, { useState } from 'react';
import { NavLink, useNavigate, Link } from 'react-router-dom';
import { RiHomeFill } from 'react-icons/ri';
import { CgArrowsExpandUpLeft, CgArrowsExpandDownRight } from 'react-icons/cg';
import { AiFillCloseCircle, AiFillCalendar } from 'react-icons/ai';
import { Sidebar } from '../components';
import { TbLayoutSidebarLeftExpand, TbLayoutSidebarRightExpand } from 'react-icons/tb';
import logo from '../assets/logo.png';
import { IoIosAdd, IoIosSearch, IoMdMenu } from 'react-icons/io';

const NavButtons = ({ user }) => {
  const [closeMenu, setCloseMenu] = useState(false);
  const [toggleSidebar, setToggleSidebar] = useState(false);
  const navigate = useNavigate();

  return (

    <div>
      {/* className='flex bg-gray-50 md:flex-row flex-col h-screen transaction-height duration-75 ease-out' */}

      <div className="flex md:hidden flex-row">
        {toggleSidebar && (
          <div className="absolute top-0 w-9/12 bg-white h-screen overflow-y-auto shadow-md z-10 animate-slide-in">

            <div className="absolute w-full flex justify-end items-center p-2">
              <AiFillCloseCircle fontSize={30} className="cursor-pointer" onClick={() => setToggleSidebar(false)} />
            </div>
            <Sidebar closeToggle={setToggleSidebar} user={user && user} />
          </div>
        )}
      </div>

      <div className="absloute bottom-0 flex md:hidden flex-row bg-transparent">

        <div className="absloute p-2 w-full flex flex-row justify-between items-center shadow-md">

          {/* <IoMdMenu fontSize={40} className="cursor-pointer" onClick={() => setToggleSidebar(true)} /> */}

          <div className='flex flex-col justify-center items-center'>
            <NavLink
              to="/search"
              className='bg-indigo-500 font-bold p-2 rounded-full w-auto m-1 outline-none'
            >
              <IoIosSearch />
            </NavLink>
            <p className='text-xs'>Search</p>
          </div>

          <div className='flex flex-col justify-center items-center'>
            <NavLink
              to="/"
              className='bg-indigo-500 font-bold p-2 rounded-full w-auto m-1 outline-none'
            >
              <RiHomeFill />
            </NavLink>
            <p className='text-xs'>Home</p>
          </div>

          <div className='flex flex-col justify-center items-center'>
            <button
              type="button"
              onClick={(e) => {
                navigate('/create-pin')
              }}
              className='bg-indigo-500 font-bold p-2 rounded-full w-auto m-1 outline-none'
            >
              <IoIosAdd />
            </button>
            <p className='text-xs'>Add</p>
          </div>

          <div className='flex flex-col justify-center items-center'>
            <Link to={`user-profile/${user?._id}`} className='p-1'>
              <img src={user?.profUrl} alt="user-pic" className="w-8 h-8 rounded-full" />
            </Link>
            <p className='text-xs'>Profile</p>
          </div>

          <div className='flex flex-col justify-center items-center'>
            <button
              type="button"
              onClick={(e) => {
                setToggleSidebar(!toggleSidebar)
              }}
              className='bg-indigo-500 font-bold p-2 rounded-full w-auto m-1 outline-none'
            >
              {toggleSidebar ? <TbLayoutSidebarRightExpand /> : <TbLayoutSidebarLeftExpand />}

            </button>
            <p className='text-xs'>Menu</p>
          </div>

        </div>
      </div>

      {/* <div className='flex'>
        {closeMenu ?
          <CgArrowsExpandUpLeft fontSize={40} className='absolute bottom-4 right-4 bg-red-500 rounded-full w-6 h-6 flex justify-center items-center z-50' onClick={() => setCloseMenu(!closeMenu)} />
          :
          <CgArrowsExpandDownRight fontSize={40} className='absolute bottom-4 right-4 bg-red-500 rounded-full w-6 h-6 flex justify-center items-center z-50' onClick={() => setCloseMenu(!closeMenu)} />
        }
        {!closeMenu &&
          <>
            <button
              type="button"
              onClick={(e) => {
                navigate('/create-pin')
              }}
              className='absolute bottom-24 right-0 bg-red-500 font-bold p-2 rounded-full w-auto m-1 outline-none'
            >
              <IoIosAdd />
            </button>

            <NavLink
              to="/"
              className='absolute bottom-20 right-11 bg-red-500 font-bold p-2 rounded-full w-auto m-1 outline-none'
            >
              <RiHomeFill />
            </NavLink>

            <NavLink
              to="/search"
              className='absolute bottom-11 right-20 bg-red-500 font-bold p-2 rounded-full w-auto m-1 outline-none'
            >
              <IoIosSearch />
            </NavLink>

            <button
              type="button"
              onClick={(e) => {
                setToggleSidebar(!toggleSidebar)
              }}
              className='absolute bottom-4 right-12 bg-red-500 font-bold p-2 rounded-full w-auto m-1 outline-none'
            >
              {toggleSidebar ? <TbLayoutSidebarRightExpand /> : <TbLayoutSidebarLeftExpand />}

            </button>
            <Link to={`user-profile/${user?._id}`}>
              <img src={user?.profUrl} alt="user-pic" className="absolute bottom-14 right-6 w-8 h-8 rounded-full" />
            </Link>

            <NavLink
              to="/calendar"
              className='absolute bottom-0 right-24 bg-red-500 font-bold p-2 rounded-full w-auto m-1 outline-none'
            >
              <AiFillCalendar />
            </NavLink>

          </>
        } */}
      {/* </div> */}
    </div>
  )
}

export default NavButtons